import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
  untracked,
} from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';

/**
 * Top bar in the GitHub/YouTube style: a simulated creep towards 90% that jumps
 * to 100% when `active` drops.
 */
@Component({
  selector: 'loading-bar',
  imports: [MatProgressBar],
  host: { class: 'pointer-events-none fixed top-0 right-0 left-0 z-50' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (visible()) {
      <mat-progress-bar
        style="--progress-bar-height: 2px"
        mode="determinate"
        [value]="value()"
      />
    }
  `,
})
export class LoadingBar {
  readonly active = input.required<boolean>();

  protected readonly visible = signal(false);
  protected readonly value = signal(0);

  constructor() {
    effect((onCleanup) => {
      if (this.active()) {
        this.value.set(10);
        this.visible.set(true);
        const creep = setInterval(
          () => this.value.update((value) => value + (90 - value) * 0.1),
          200
        );
        onCleanup(() => clearInterval(creep));
      } else if (untracked(this.visible)) {
        this.value.set(100);
        const hide = setTimeout(() => this.visible.set(false), 300);
        onCleanup(() => clearTimeout(hide));
      }
    });
  }
}
